import * as yup from 'yup';

const passwordMatchesMessage =
	'The password must be between 8 and 50 characters long, including at least 1 upper case letter, 1 lower case letter, 1 number, and 1 symbol.';

export const updateUserPasswordSchema = yup.object({
	newPassword: yup
		.string()
		.required('The password is required.')
		.min(8, passwordMatchesMessage)
		.max(50, passwordMatchesMessage)
		.matches(/[a-z]/, passwordMatchesMessage)
		.matches(/[A-Z]/, passwordMatchesMessage)
		.matches(/[0-9]/, passwordMatchesMessage)
		.matches(/\W/, passwordMatchesMessage),
	confirmPassword: yup.string().when('newPassword', (newPassword, schema) => {
		return newPassword
			? schema
					.required(
						'The confirmation password is required when changing the password',
					)
					.oneOf([yup.ref('newPassword')], 'Passwords must match')
			: schema.notRequired();
	}),
	password: yup.string().when('newPassword', (newPassword, schema) => {
		return newPassword
			? schema.required(
					'The confirmation password is required when changing the password',
			  )
			: schema.notRequired();
	}),
});
